import {_request, _requestForm} from "./api";

export const add = (date,entities_guide) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _request({
            target: 'contact/'+String(entities_guide), method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (date,contact_guid) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _request({
            target: `contact/${contact_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (document_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `contact/${document_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'contact/item', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (entities_guide) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'contact/'+String(entities_guide), method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const contactType = (entities_type_id) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'contact/type/'+String(entities_type_id), method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
